module.exports = __webpack_public_path__ + "img/color-1.e8828ac.webp";